// Funções liga/desliga por conta (05/11/2026): tabela funcionalidade_conta do banco do CRM, lida em
// GET /funcionalidades?id_grupo=. Liga/desliga é DIRETO NO BANCO (sem tela por enquanto).
// Sem linha = desligada. Hoje: "discadora" (área + mailing) e "discadora_ligar" (botão Ligar).
//
// Lê uma vez por carregamento de página (por conta) e guarda a última resposta no localStorage, para
// as checagens síncronas (menu, rotas) já saberem na próxima abertura. Falha de rede = última resposta
// guardada; sem nenhuma = tudo desligado.
import { useEffect, useState } from "react";
import { API_URL } from "../../environment";

export type Funcionalidades = Record<string, Record<string, any>>; // nome -> opcoes (só as ligadas)

export const EVENTO_FUNCIONALIDADES = "funcionalidades-atualizadas";

const grupoAtual = () => localStorage.getItem("id_grupo") || "";
const chaveCache = (g: string) => `funcionalidades:${g}`;

export const lerFuncionalidades = (): Funcionalidades | null => {
  const g = grupoAtual();
  if (!g) return null;
  try {
    const v = localStorage.getItem(chaveCache(g));
    return v ? (JSON.parse(v) as Funcionalidades) : null;
  } catch {
    return null;
  }
};

let pedido: { g: string; promessa: Promise<Funcionalidades> } | null = null;

export const carregarFuncionalidades = (forcar = false): Promise<Funcionalidades> => {
  const g = grupoAtual();
  if (!g) return Promise.resolve({});
  if (pedido && pedido.g === g && !forcar) return pedido.promessa;
  const promessa = fetch(`${API_URL}/funcionalidades?id_grupo=${encodeURIComponent(g)}`)
    .then((r) => (r.ok ? r.json() : Promise.reject(new Error(`HTTP ${r.status}`))))
    .then((d) => {
      const f: Funcionalidades = d?.funcionalidades && typeof d.funcionalidades === "object" ? d.funcionalidades : {};
      const antes = localStorage.getItem(chaveCache(g));
      const agora = JSON.stringify(f);
      localStorage.setItem(chaveCache(g), agora);
      if (antes !== agora) window.dispatchEvent(new Event(EVENTO_FUNCIONALIDADES));
      return f;
    })
    .catch(() => lerFuncionalidades() || {});
  pedido = { g, promessa };
  return promessa;
};

export const funcionalidadeAtiva = (nome: string, f: Funcionalidades | null = lerFuncionalidades()): boolean =>
  !!f && Object.prototype.hasOwnProperty.call(f, nome);

export const opcoesFuncionalidade = (nome: string, f: Funcionalidades | null = lerFuncionalidades()) =>
  (f && f[nome]) || null;

// Para componentes: devolve a última resposta guardada já no primeiro render e atualiza quando a
// leitura do servidor chega. `carregado` = já veio a resposta desta página.
export const useFuncionalidades = () => {
  const [f, setF] = useState<Funcionalidades | null>(() => lerFuncionalidades());
  const [carregado, setCarregado] = useState(false);
  useEffect(() => {
    let vivo = true;
    carregarFuncionalidades().then((x) => {
      if (!vivo) return;
      setF(x);
      setCarregado(true);
    });
    const ouvir = () => vivo && setF(lerFuncionalidades());
    window.addEventListener(EVENTO_FUNCIONALIDADES, ouvir);
    return () => {
      vivo = false;
      window.removeEventListener(EVENTO_FUNCIONALIDADES, ouvir);
    };
  }, []);
  return { funcionalidades: f, carregado };
};
